import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import ConfigsState from '../../types/ConfigsState'
import Configs from '../../types/Configs'
import AllowedCountries from "../../types/AllowedCountries";

const mutations: MutationTree<ConfigsState> = {
  [types.SET_CONFIGS] (state, payload: Configs[]) {
    state.configs = payload
  },
  [types.SET_ALLOWED_COUNTRIES] (state, payload: AllowedCountries) {
    state.allowed_countries = payload
  }
}

export default mutations
